export const UPDATE_PAY_USER_CARD_REQUEST = 'UPDATE_PAY_USER_CARD_REQUEST';
export const UPDATE_PAY_USER_CARD_SUCCESS = 'UPDATE_PAY_USER_CARD_SUCCESS';
export const UPDATE_PAY_USER_CARD_FAILURE = 'UPDATE_PAY_USER_CARD_FAILURE';
